import RcSlider from 'rc-slider';
import { SliderProps as RcSliderProps } from 'rc-slider';
import { InputLabel } from './input-label';
import { useField } from '@/components/form';
import { ErrorField } from '../error-field';
import 'rc-slider/assets/index.css';
import './slider.css';

interface SliderProps extends Omit<RcSliderProps<number | number[]>, 'tabIndex' | 'onChange'> {
  name: string;
  label: string;
  min?: number;
  max?: number;
}

export function Slider({
  name,
  label,
  min = 0,
  max = 10,
  defaultValue,
  ...restProps
}: SliderProps) {
  const { getValue, setValue, error } = useField<number | number[]>(name, restProps);

  const value = getValue();

  // The value/defaultValue can be 0
  if (value === undefined && defaultValue !== undefined) {
    setValue(defaultValue);
  }

  const marks = Array.from({ length: max - min + 1 }, (_, i) => min + i).reduce(
    (acc, mark) => ({
      ...acc,
      [mark]: mark,
    }),
    {},
  );

  return (
    <div>
      <InputLabel label={label} htmlFor={name} />
      <RcSlider min={min} max={max} value={value} step={1} onChange={setValue} marks={marks} />

      <ErrorField error={error} />
    </div>
  );
}
